// Format phone number to E.164 format for database storage: +1xxxxxxxxxx
export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // If it's a 10-digit number, assume US and add +1
  if (cleaned.length === 10) {
    return `+1${cleaned}`;
  }
  
  // If it's 11 digits and starts with 1, add +
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `+${cleaned}`;
  }
  
  // Return original if not valid
  return phoneNumber;
};

// Format phone number for display: +1 (xxx) xxx-xxxx
export const formatPhoneNumberForDisplay = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Check if we have a valid number
  if (cleaned.length !== 11 || !cleaned.startsWith('1')) return phoneNumber;
  
  // Format the number for display
  return `+${cleaned[0]} (${cleaned.slice(1,4)}) ${cleaned.slice(4,7)}-${cleaned.slice(7)}`;
};

// Convert phone number to storage format: +xxxxxxxxxxx
export const normalizePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  
  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // If we don't have exactly 11 digits (including country code), return empty string
  if (cleaned.length !== 11) return '';
  
  return `+${cleaned}`;
};

// Validate phone number
export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  
  // Remove all non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '');
  
  // Must be exactly 11 digits (1 for country code + 10 for phone number)
  return cleaned.length === 11 && cleaned[0] === '1';
};

// Format phone number as user types
export const formatPhoneNumberInput = (value) => {
  if (!value) return '';
  
  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, '');
  
  // Build the formatted string as the user types
  let formatted = '';
  
  if (cleaned.length > 0) {
    formatted = '+' + cleaned[0];
  }
  if (cleaned.length > 1) {
    formatted += ' (';
  }
  if (cleaned.length > 1) {
    formatted += cleaned.slice(1, 4);
  }
  if (cleaned.length > 4) {
    formatted += ') ';
  }
  if (cleaned.length > 4) {
    formatted += cleaned.slice(4, 7);
  }
  if (cleaned.length > 7) {
    formatted += '-';
  }
  if (cleaned.length > 7) {
    formatted += cleaned.slice(7, 11);
  }
  
  return formatted;
};
